import { enforce, omitWhen, test } from 'vest';

import {
  isEndpointUrl,
  withDefaults,
} from 'admin-panel/utils/integrations/config';

import type { IntegrationConfig } from 'admin-panel/models/integrations/configuration';
import type {
  IntegrationFormValues,
  ServiceFormDefinition,
} from 'admin-panel/utils/integrations/types';

export interface HotsoftService {
  providerKey: string;
  hotelCode: string;
  endpoint: string;
}

const SERVICE = 'currentConfig.service';

const defaultConfig = (): IntegrationConfig => ({
  service: {
    providerKey: '',
    hotelCode: '',
    endpoint: '',
  },
  features: {},
  cron: [{ name: 'full_reservation_sync', task: 'full_reservation_sync' }],
  webhooks: [],
});

export const hotsoft: ServiceFormDefinition = {
  toFormConfig: (config) => withDefaults(defaultConfig(), config),

  validate(values: IntegrationFormValues, t) {
    const service = values.currentConfig.service as unknown as HotsoftService;

    test(`${SERVICE}.providerKey`, t('validations.required'), () => {
      enforce(service.providerKey).isNotBlank();
    });

    test(`${SERVICE}.hotelCode`, t('validations.required'), () => {
      enforce(service.hotelCode).isNotBlank();
    });

    test(`${SERVICE}.endpoint`, t('validations.required'), () => {
      enforce(service.endpoint).isNotBlank();
    });

    omitWhen(!service.endpoint, () => {
      test(`${SERVICE}.endpoint`, t('validations.url'), () => {
        enforce(isEndpointUrl(service.endpoint)).isTruthy();
      });
    });
  },
};
